import {
  faShop,
  faChartLine,
  faCartShopping,
  faUserCog,
  faCube,
  faCog,
  faList,
  faUserShield,
  faUser,
  faAlignCenter,
  faUsers,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import UserManagementPage from "../pages/administration";
import ServiceGroupPage from "../pages/administration/groups";
import UserServicePage from "../pages/administration/services";
import { ServiceType } from "../type/service";
import OrderPage from "../pages/orders/index";
import SingleReturnOrderDetailsPage from "../pages/orders/returnOrderDetails";
import myShopReturnOrderDetailsPage from "../pages/orders/myShopReturnOrderDetails";
import MyBusinessPage from "../pages/shops/index";
import ShopDetailsPage from "../pages/shops/details";
import MyShopDetailsPage from "../pages/shops/shopDetails";
import ShopContractInfoPage from "../pages/shops/shopContractInfo";
import ShopOrderPage from "../pages/shops/orders/index";
import MyShopOrderPage from "../pages/shops/orders/shopOderList";
import ShopReturnOrderPage from "../pages/shops/orders/returnOrders";
import MyShopReturnOrderPage from "../pages/shops/orders/myshopreturnOrders";
import ShopManualOrderPage from "../pages/shops/orders/manual-order-create";
import MyShopManualOrderPage from "../pages/shops/orders/myshop-manual-order-create";
import ShopProductOutOfStockPage from "../pages/shops/products/out-of-stock";
import MyShopProductOutOfStockPage from "../pages/shops/products/myshop-out-of-stock";
import ShopBrandsPage from "../pages/shops/brands";
import ShopUserPage from "../pages/shops/users/index";
import ShopBanksPage from "../pages/shops/banks";
import MyShopBanksPage from "../pages/shops/banks/shopBank";
import ShopBusinessInfoPage from "../pages/shops/businessInfo";
import ShopBusinessInfoUpdatePage from "../pages/shops/businessInfo/edit";
import ShopContractAddressPage from "../pages/shops/contract-address";
import MyShopBusinessInfoPage from "../pages/shops/businessInfo/shopBusinessInfo";

import ShopFacebookPageGroupPage from "../pages/shops/facook/index";
import ShopContractAddressUpdatePage from "../pages/shops/contract-address/edit";
import ShopDeliveryShippingPage from "../pages/shops/delivery-shipping/index";
import ShopShippingAddRatePage from "../pages/shops/delivery-shipping/add-rate";
import ShopShippingProfilePage from "../pages/shops/delivery-shipping/add-rate";
import BrandDetailsPage from "../pages/brands/details";
import ShopAddPage from "../pages/shops/add";
import SingleOrderPage from "../pages/orders/details";
import ShopProductPage from "../pages/shops/products";
import MyShopProductPage from "../pages/shops/products/shopProductList";
import ShopAffiliateProductPage from "../pages/shops/affiliate/index";
import ShopRequestedProductPage from "../pages/shops/products/requested-products";
import MyShopRequestedProductPage from "../pages/shops/products/myshopRequested-products";
import ShopProductCataloguePage from "../pages/shops/products/productCatalogue";
import MyShopProductCataloguePage from "../pages/shops/products/myShopProductCatalogue";
import ShopRequestProductDetailsPage from "../pages/requested-products/details";
import MyShopProductDetailsPage from "../pages/shops/products/productDetails";
import ShopCategoryPage from "../pages/shops/categories";
import MyShopCategoryPage from "../pages/shops/categories/shopCategoryes";
import MerchantOrderDetailsPage from "../pages/shops/orders/details";
import MyShopOrderDetailsPage from "../pages/shops/orders/myShopOrderDetails";
import ShopProductAddPage from "../pages/shops/products/add";
import ShopRequestProductAddPage from "../pages/shops/products/add-req-product";
import ShopProductBulkUploadPage from "../pages/shops/products/bulkupload";
import ShopProductBulkUpdatePage from "../pages/shops/products/buklupdate";
import ShopRequestProductEditPage from "../pages/shops/products/request-product-edit";
import ShopProductEditPage from "../pages/shops/products/edit";
import ShopCampaignPage from "../pages/shops/promotions/campaign";
import MyShopCampaignPage from "../pages/shops/promotions/campaign/shopCampaign";
import ShopPromoCodePage from "../pages/shops/promotions/campaign/promo-codes";
import MyShopPromoCodePage from "../pages/shops/promotions/campaign/shop-promo-codes";
import CampaignDetailsPage from "../pages/promotions/campaign/details";
import OrderCreatePage from "../pages/orders/manual-order-create";
import MainSellerDashboardPage from "../pages/main-seller-dashboard";
import CampaignAssignProductPage from "../pages/promotions/campaign/assign-products";
import CampaignProductPage from "../pages/promotions/campaign/products";
import BankDetailsPage from "../pages/account-settings/bank";
import MerchantDetailsPage from "../pages/account-settings";
import ProfileEditPage from "../pages/account-settings/profile-update";
import MerchantProfileUpdatePage from "../pages/account-settings/profile-update";
import WarehouseInfoPage from "../pages/account-settings/warehouse";
import ShopChatPage from "../pages/shops/chats/index";
import KeyAccountPage from "../pages/account-settings/key-account-manager";
import ReferralsPage from "../pages/account-settings/referrals";
import SalesReportPage from "../pages/reports/sales-report";
import SalesSummaryReportPage from "../pages/reports/sales-summary";
import TopSalesProductReportPage from "../pages/reports/top-sales-product";
import TopSalesProductDetailsReportPage from "../pages/reports/top-sales-product-details";
import TopSalesCategoryReportPage from "../pages/reports/sales-category-wise-product";
import ReturnSalesReportPage from "../pages/reports/return-sales-report";
import ReturnSalesSummaryReportPage from "../pages/reports/return-sales-summary-report";
import ReturnSalesProductDetailsReportPage from "../pages/reports/return-sales-product-details";

import StockOutProductSummaryReportPage from "../pages/reports/StockOutProductSummaryReportPage";
import StockOutProductSummaryWithDateReportPage from "../pages/reports/StockOutProductSummaryWithDateReportPage";
import ReturntopSalesProductSummaryReportPage from "../pages/reports/ReturntopSalesProductSummaryReportPage";
import ReturnSalesCategoryWiseReportPage from "../pages/reports/ReturnSalesCategoryWiseReportPage";
import PromoWiseSalesReportPage from "../pages/reports/PromoWiseSalesReportPage";

import RevenueReportPage from "../pages/reports/revenue-report";
import { SolutionOutlined } from "@ant-design/icons";
export const isAllowedService = (name: string) => {
  const services = localStorage.getItem("services");

  if (services) {
    const listfromApi: ServiceType[] = JSON.parse(services);
    const data = listfromApi.find((itemfromApi) => {
      return itemfromApi.serviceName === name;
    });
    if (data) {
      return true;
    }
  }
  return false;
};

export const allowedActions = (name: string) => {
  const services = localStorage.getItem("services");

  if (services) {
    const list: ServiceType[] = JSON.parse(services);
    const data = list.filter((item) => item.serviceName === name);
    if (data.length > 0) {
      data.map((d) => d.action);
    }
  }
  return [];
};

export const isEditableService = (name: string) => {
  const services = localStorage.getItem("services");

  if (services) {
    const list: ServiceType[] = JSON.parse(services);
    const data = list.find(
      (item) => item.serviceName === name && item.action === "all"
    );

    if (data) {
      return true;
    }
  }
  return false;
};

export const getAllServices = () => {
  const services = localStorage.getItem("services");
  if (services) {
    return JSON.parse(services);
  }
  return [];
};

type AdminService = {
  name: string;
  path?: string;
  icon?: any;
  element?: any;
  sub?: AdminService[];
  isParent?: boolean;
};

export const adminServices: AdminService[] = [
  //Main Seller Dashboard
  {
    name: "Dashboard",
    path: "/",
    icon: faChartLine,
    element: MainSellerDashboardPage,
  },
  // Store Routes
  {
    name: "Manage Business",
    path: "/shops",
    icon: faShop,
    sub: [
      {
        name: "My Business",
        path: "/mybusiness",
        icon: faShop,
        element: MyBusinessPage,
        isParent: true,
      },
      {
        name: "Shop Create",
        path: "/create",
        element: ShopAddPage,
      },

      {
        name: "Edit",
        path: "/:shopId/edit",
        element: ShopAddPage,
      },
      {
        name: "Shop General Info Edit",
        path: "/:shopId/shop-general-info-edit",
        element: ShopAddPage,
      },
      {
        name: "Details",
        path: "/:shopId/details",
        element: ShopDetailsPage,
      },
      {
        name: "shop Details",
        path: "/:shopId/myshop-details",
        element: MyShopDetailsPage,
      },
      {
        name: "Shop Business & Contract Info",
        path: "/:shopId/shop-business-contract-info",
        element: ShopContractInfoPage,
      },
      {
        name: "Orders",
        path: "/:shopId/orders",
        element: ShopOrderPage,
      },
      {
        name: "shop Orders",
        path: "/:shopId/myshop-orders",
        element: MyShopOrderPage,
      },
      {
        name: "Manual Orders",
        path: "/:shopId/manual-orders",
        element: ShopManualOrderPage,
      },
      {
        name: "shop Manual Orders",
        path: "/:shopId/myshop-manual-orders",
        element: MyShopManualOrderPage,
      },
      {
        name: "Merchant Order Details",
        path: "/:orderId/merchant-order-details",
        element: MerchantOrderDetailsPage,
      },
      {
        name: "My Shop Orders Details",
        path: "/:orderId/myshop-order-details",
        element: MyShopOrderDetailsPage,
      },
      {
        name: "Out-Of-Stock",
        path: "/:shopId/out-of-stock",
        element: ShopProductOutOfStockPage,
      },
      {
        name: "Shop-Out-Of-Stock",
        path: "/:shopId/myshop-out-of-stock",
        element: MyShopProductOutOfStockPage,
      },
      {
        name: "Shop Return Order",
        path: "/:shopId/return-order",
        icon: faCopy,
        element: ShopReturnOrderPage,
        isParent: true,
      },
      {
        name: "My Shop Return Order",
        path: "/:shopId/myshop-return-order",
        icon: faCopy,
        element: MyShopReturnOrderPage,
        isParent: true,
      },
      {
        name: "Shop Return Order Details",
        path: "/:orderId/return-order-details",
        element: SingleReturnOrderDetailsPage,
      },
      {
        name: "My Shop Return Order Details",
        path: "/:orderId/myshop-return-order-details",
        element: myShopReturnOrderDetailsPage,
      },
      {
        name: "Brands",
        path: "/:shopId/brands",
        element: ShopBrandsPage,
      },
      {
        name: "Bank",
        path: "/:shopId/banks",
        element: ShopBanksPage,
      },
      {
        name: "Shop Bank",
        path: "/:shopId/shop-banks",
        element: MyShopBanksPage,
      },
      {
        name: "Buiness Info",
        path: "/:shopId/business-info",
        element: ShopBusinessInfoPage,
      },
      {
        name: "Buiness Info Update",
        path: "/:shopId/business-info-update",
        element: ShopBusinessInfoUpdatePage,
      },
      {
        name: "Shop Buiness Info Update",
        path: "/:shopId/shop-business-info-update",
        element: ShopBusinessInfoUpdatePage,
      },
      {
        name: "Shop Product Request",
        path: "/:shopId/shop-product-request",
        element: ShopBusinessInfoUpdatePage,
      },
      {
        name: "Business & Contact Address",
        path: "/:shopId/contact-address",
        element: ShopContractAddressPage,
      },
      {
        name: "Shop Business Info",
        path: "/:shopId/shop-business-info",
        element: MyShopBusinessInfoPage,
      },
      {
        name: "Facebook Page & Group",
        path: "/:shopId/facebook-page",
        element: ShopFacebookPageGroupPage,
      },
      {
        name: "Business & Contact update",
        path: "/:shopId/contact-update",
        element: ShopContractAddressUpdatePage,
      },
      {
        name: "Shipping & Delivery Settings",
        path: "/:shopId/shop-delivery-settings",
        element: ShopDeliveryShippingPage,
      },
      {
        name: "Add Rate",
        path: "/:shopId/shipping/:zoneId/add-rate",
        element: ShopShippingAddRatePage,
      },
      {
        name: "Edit Rate",
        path: "/:shopId/shipping/:zoneId/edit-rate",
        element: ShopShippingAddRatePage,
      },
      {
        name: "shipping-profile",
        path: "/:shopId/shipping-profile",
        element: ShopShippingProfilePage,
      },
      {
        name: "Products",
        path: "/:shopId/products",
        element: ShopProductPage,
      },
      {
        name: "Shop Products",
        path: "/:shopId/my-shop-products",
        element: MyShopProductPage,
      },
      {
        name: "Affiliate Products",
        path: "/:shopId/affiliate-products",
        element: ShopAffiliateProductPage,
      },
      {
        name: "Requested Products",
        path: "/:shopId/requested-products",
        element: ShopRequestedProductPage,
      },
      {
        name: "Shop Requested Products",
        path: "/:shopId/myshop-requested-products",
        element: MyShopRequestedProductPage,
      },
      {
        name: "Request Product Details",
        path: "/:shopId/request-products/:slug/details",
        element: ShopRequestProductDetailsPage,
      },
      {
        name: "Request Product Edit",
        path: "/:shopId/request-products/:slug/edit",
        element: ShopRequestProductEditPage,
      },
      {
        name: "Product Catalogue",
        path: "/:shopId/product-catalogue",
        element: ShopProductCataloguePage,
      },
      {
        name: "Shop Product Catalogue",
        path: "/:shopId/myshop-product-catalogue",
        element: MyShopProductCataloguePage,
      },
      {
        name: "Product Details",
        path: "/:slug/shop-products-details",
        element: MyShopProductDetailsPage,
      },
      {
        name: "Product Add",
        path: "/:shopId/products/create",
        element: ShopProductAddPage,
      },
      {
        name: "Product Bulkupload",
        path: "/:shopId/products/bulkupload",
        element: ShopProductBulkUploadPage,
      },
      {
        name: "Product Bulkupdate",
        path: "/:shopId/products/bulkupdate",
        element: ShopProductBulkUpdatePage,
      },
      {
        name: "Product Edit",
        path: "/:shopId/products/:slug/edit",
        element: ShopProductEditPage,
      },
      {
        name: "Campaign",
        path: "/:shopId/campaign",
        element: ShopCampaignPage,
      },
      {
        name: "Shop Campaign",
        path: "/:shopId/myshop-campaign",
        element: MyShopCampaignPage,
      },
      {
        name: "Campaign Details",
        path: "/:shopId/campaign/:campaignId/details",
        element: CampaignDetailsPage,
      },
      {
        name: "Campaign Product",
        path: "/:shopId/campaign/:campaignId/campaign-products",
        element: CampaignProductPage,
      },
      {
        name: "Campaign Product Assign",
        path: "/:shopId/campaign/:campaignId/assign-products",
        element: CampaignAssignProductPage,
      },
      {
        name: "Promo Code",
        path: "/:shopId/promo-code",
        element: ShopPromoCodePage,
      },
      {
        name: "Shop Promo Code",
        path: "/:shopId/myshop-promo-code",
        element: MyShopPromoCodePage,
      },
      {
        name: "Sales Report",
        path: "/:shopId/sales-report",
        icon: faAlignCenter,
        element: SalesReportPage,
      },
      {
        name: "Sales Summary",
        path: "/:shopId/sales-summary",
        element: SalesSummaryReportPage,
      },
      {
        name: "Top Sales Product",
        path: "/:shopId/top-sales-product",
        element: TopSalesProductReportPage,
      },
      {
        name: "Top Sales Product Details",
        path: "/:shopId/top-sales-product-details",
        element: TopSalesProductDetailsReportPage,
      },
      {
        name: "Sales Category Wise Report",
        path: "/:shopId/sales-category-wise-report",
        element: TopSalesCategoryReportPage,
      },
      {
        name: "Return Sales Report",
        path: "/:shopId/return-sales-report",
        element: ReturnSalesReportPage,
      },
      {
        name: "Return Sales Summary",
        path: "/:shopId/return-sales-summary-report",
        element: ReturnSalesSummaryReportPage,
      },
      {
        name: "Return Sales Product Details",
        path: "/:shopId/return-top-sales-product-details-report",
        element: ReturnSalesProductDetailsReportPage,
      },
      {
        name: "Stock Out Product Summary",
        path: "/:shopId/stock-out-product-summary-report",
        element: StockOutProductSummaryReportPage,
      },
      {
        name: "Stock Out Product Summary With Date",
        path: "/:shopId/stock-out-product-summary-report-with-date-wise",
        element: StockOutProductSummaryWithDateReportPage,
      },
      {
        name: "Return Top Sales Product Summary",
        path: "/:shopId/return-top-sales-product-summary-report",
        element: ReturntopSalesProductSummaryReportPage,
      },
      {
        name: "Return Sales Category Wise",
        path: "/:shopId/return-sales-category-wise-report",
        element: ReturnSalesCategoryWiseReportPage,
      },
      {
        name: "Promo Wise Sales Report",
        path: "/:shopId/promo-wise-sales-report",
        element: PromoWiseSalesReportPage,
      },
      {
        name: "Categories",
        path: "/:shopId/categories",
        element: ShopCategoryPage,
      },
      {
        name: "Shop Categories",
        path: "/:shopId/myshop-categories",
        element: MyShopCategoryPage,
      },
      {
        name: "Users",
        path: "/:shopId/users",
        element: ShopUserPage,
      },
    ],
  },
  // Orders Routes
  {
    name: "Orders & Reviews",
    path: "/orders",
    icon: faCartShopping,
    sub: [
      {
        name: "List",
        path: "/",
        icon: faCartShopping,
        element: OrderPage,
        isParent: true,
      },

      {
        name: "Details",
        path: "/:orderId/details",
        element: SingleOrderPage,
      },
      {
        name: "Manual Order",
        path: "/create",
        element: OrderCreatePage,
      },

      {
        name: "Extra",
      },
    ],
  },

  // Analytics Routes
  {
    name: "Analytics",
    path: "/reports",
    icon: faList,
    sub: [
      {
        name: "Revenue Report",
        path: "/revenue-report",
        icon: faAlignCenter,
        element: RevenueReportPage,
      },
    ],
  },
  // Account & Settings
  {
    name: "Refer & Reward",
    path: "/referrals",
    icon: faCube,
    element: ReferralsPage,
  },

  {
    name: "Personal Details",
    path: "/my-profile",
    icon: faUserCog,
    sub: [
      {
        name: "Personal Details",
        path: "/",
        icon: faCartShopping,
        element: MerchantDetailsPage,
        isParent: true,
      },
      {
        name: "Profile Edit",
        path: "/:id/my-profile-edit",
        element: ProfileEditPage,
      },
    ]
    
  },

  //Administration Routes
  {
    name: "Administration",
    path: "/administration",
    icon: faUserShield,
    sub: [
      {
        name: "User Management",
        icon: faUser,
        path: "/admins",
        element: UserManagementPage,
      },
      {
        name: "User Groups",
        icon: faUsers,
        path: "/groups",
        element: ServiceGroupPage,
      },
      {
        name: "User Services",
        icon: faList,
        path: "/services",
        element: UserServicePage,
      },
    ],
  },

  {
    name: "Chats",
    path: "/:shopId/chats",
    icon: SolutionOutlined,
    element: ShopChatPage,
  },
];

export const getAllServicesList = () => {
  return adminServices?.flatMap((service) => {
    if (service.sub && service.sub.length) {
      return service.sub.map((sub) => `${service.name} ${sub.name}`);
    } else {
      return service.name;
    }
  });
};

export const getServicePaths = (path: string | undefined) => {
  if (path) {
    const parentService = adminServices?.find(
      (service) => service.path === path
    );
    if (parentService) {
      return parentService?.path || "";
    } else {
      const parentService = adminServices?.find((service) =>
        service.sub?.find((sub) => `${service.path}${sub.path}` === path)
      );
      return parentService?.path || "";
    }
  }
  return "";
};
